export const CONTROLE_PRODUCAO = () => '/controle-producao';
